import { type Table, type RowData, type ColumnPinningState, type OnChangeFn } from "@tanstack/react-table";
import { createContext, use } from "react";

export interface TableContextValue<TData extends RowData = any> {
  table: Table<TData>;
  loading: boolean;
  error: string | undefined;
  columnOrder: string[];
  columnPinning: ColumnPinningState;
  onColumnPinningChange: OnChangeFn<ColumnPinningState>;
}

export const TableContext = createContext<TableContextValue<any> | null>(null);

export function useTableContext<TData extends RowData = any>(): TableContextValue<TData> {
  const context = use(TableContext);
  if (!context) {
    throw new Error("useTableContext must be used within a TableRoot");
  }
  return context as TableContextValue<TData>;
}
